import { render, staticRenderFns } from "./InlineNoteField.vue?vue&type=template&id=39d0a2f0&scoped=true"
import script from "./InlineNoteField.vue?vue&type=script&lang=js"
export * from "./InlineNoteField.vue?vue&type=script&lang=js"
import style0 from "./InlineNoteField.vue?vue&type=style&index=0&id=39d0a2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d0a2f0",
  null
  
)

export default component.exports